"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.titleCase = exports.wordsToNumber = void 0;
const Small = {
    zero: 0,
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6,
    seven: 7,
    eight: 8,
    nine: 9,
    ten: 10,
    eleven: 11,
    twelve: 12,
    thirteen: 13,
    fourteen: 14,
    fifteen: 15,
    sixteen: 16,
    seventeen: 17,
    eighteen: 18,
    nineteen: 19,
    twenty: 20,
    thirty: 30,
    forty: 40,
    fifty: 50,
    sixty: 60,
    seventy: 70,
    eighty: 80,
    ninety: 90,
};
function wordsToNumber(s, checkForDigits = false) {
    if (!s) {
        return 0;
    }
    const words = s.toString().split(/[\s-]+/);
    let total = 0;
    words.forEach((word) => {
        const wordKey = Small[word];
        if (wordKey !== undefined) {
            total += wordKey;
        }
        else if (checkForDigits && !isNaN(parseFloat(word))) {
            total += parseFloat(word);
        }
    });
    return total;
}
exports.wordsToNumber = wordsToNumber;
function titleCase(input) {
    return input
        .split(' ')
        .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
        .join(' ');
}
exports.titleCase = titleCase;
